import React from 'react';
import Image from 'next/image';
import { classNames } from '@repo/ui/src/utils/classNames';

const SmokeImages = ({ smokeImgUrl, isAnimating }: { smokeImgUrl: string; isAnimating: any }) => {
  return (
    <div
      className={classNames(
        'smoke-wrapper absolute bottom-0 left-0 w-full z-0 pt-[32.25%] motion-reduce:opacity-80 motion-reduce:translate-y-1/3 overflow-y-hidden pointer-events-none',
      )}
    >
      <div className="w-full h-full absolute -bottom-[85%]">
        <Image
          src={smokeImgUrl}
          role="presentation"
          alt=""
          layout="fill"
          data-testid="smoke-image"
          className={classNames('object-cover opacity-0', isAnimating && 'animate-scale-up-1')}
        />
      </div>
      <div className="w-full h-full absolute -bottom-3/4">
        <Image
          src={smokeImgUrl}
          role="presentation"
          alt=""
          layout="fill"
          className={classNames('object-cover opacity-0', isAnimating && 'animate-scale-up-2')}
        />
      </div>
      <div className="w-full h-full absolute -bottom-3/4">
        <Image
          src={smokeImgUrl}
          role="presentation"
          alt=""
          layout="fill"
          className={classNames('object-cover opacity-0', isAnimating && 'animate-scale-up-3')}
        />
      </div>
    </div>
  );
};

export default SmokeImages;
